import { Link } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";
import { EmailAuthForm } from "../components/EmailAuthForm";
import { useRedirectIfAuthed } from "../components/RouteGuards";
import { useNoindex } from "../hooks/useNoindex";

export default function Login() {
  useNoindex();
  useRedirectIfAuthed();
  return (
    <AuthLayout testId="login-page" eyebrow="Welcome back" title="Sign in to your portal" subtitle="Access the profiles personally selected for you.">
      <EmailAuthForm
        mode="login"
        extra={
          <div className="flex justify-end">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-sm font-medium text-[#7A0016] hover:underline">
              Forgot password?
            </Link>
          </div>
        }
        footer={
          <>New to Real Match?{" "}
            <Link to="/register" data-testid="go-to-register-link" className="font-semibold text-[#7A0016] hover:underline">Register your profile</Link>
          </>
        }
      />
    </AuthLayout>
  );
}
